const GA_ID = import.meta.env.VITE_GA_ID as string | undefined
const PLAUSIBLE_DOMAIN = import.meta.env.VITE_PLAUSIBLE_DOMAIN as string | undefined

function PlausibleScript() {
  if (!PLAUSIBLE_DOMAIN) {return null}
  return (
    <script
      defer
      data-domain={PLAUSIBLE_DOMAIN}
      src="https://plausible.io/js/script.outbound-links.js"
    />
  )
}

function GoogleAnalyticsScript() {
  if (!GA_ID) {return null}
  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_ID}', {
              anonymize_ip: true,
              cookie_flags: 'SameSite=None;Secure'
            });
          `,
        }}
      />
    </>
  )
}

export function Analytics() {
  return (
    <>
      <PlausibleScript />
      <GoogleAnalyticsScript />
    </>
  )
}

export function trackEvent(name: string, params?: Record<string, unknown>) {
  if (typeof window === "undefined") {return}
  const plausible = (window as unknown as { plausible?: (n: string, o?: { props: unknown }) => void }).plausible
  if (plausible && params) {
    plausible(name, { props: params })
  } else if (plausible) {
    plausible(name)
  }
  const gtag = (window as unknown as { gtag?: (type: string, name: string, params?: Record<string, unknown>) => void }).gtag
  if (gtag) {
    gtag("event", name, params)
  }
}
